export default "__VITE_ASSET__DhdE897d__"